  import Samp from "@/views/samp/Samp"
  import {nosamp} from './nosamp'
  import {havesamp} from './havesamp'
  export const samp = {
    path: '/samp',
    name: 'Samp',
    component: Samp,
    children:[
      nosamp,havesamp
    ]
  }


// WEBPACK FOOTER //
// ./src/router/index/samp/index.js